// /* eslint-disable @typescript-eslint/no-unused-vars */
// /* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl';
import { useFormik } from 'formik'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom';
import { RootState } from '../../../setup';
import { useAuth } from '../../../setup/context/AppContext';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { HeaderWrapper } from '../../../_metronic/layout/components/header/SearchHeaderWrapper';
import { UserModel } from '../auth/models/UserModel';
import { SearchResults } from './components/SearchResults';
import { deleteCompany, getPartnerOptions, getSearchData, getStatus, getTranslateData } from './redux/SearchFilterCRUD';
import * as search from './redux/SearchFilterRedux'
import * as auth from '../auth/redux/AuthRedux'
import SelectSearch from './components/SelectSearch';
import { Content } from '../../../_metronic/layout/components/Content';


export function SearchFilterPage() {
  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const { currentStep, handleCurrentStep, handleShowCompany } = useAuth();

  const [loading, setLoading] = useState(false)

  const history = useHistory();
  const dispatch = useDispatch();

  const [hasIssue, setHasIssue] = useState<boolean>(false);
  const [erp, setErp] = useState<string>("");
  const [partner, setPartner] = useState<string>("");
  const [customer, setCustomer] = useState<string>("");
  const [cloud, setCloud] = useState<boolean>(false);
  const [solo, setSolo] = useState<boolean>(false);
  const [enterprise, setEnterprise] = useState<boolean>(false);
  const [partnerCheck, setPartnerCheck] = useState<boolean>(false);
  const [state, setState] = useState<any>({})
  const [totalData, setTotalData] = useState<any>([]);

  const [erpOptions, setErpOptions] = useState<any[]>([]);
  const [partnerOptions, setPartnerOptions] = useState<any[]>([]);
  const [statusOptions, setStatusOptions] = useState<any[]>([]);
  const [searchColumns, setSearchColumns] = useState<any>([]);

  const [erpDisabled, setErpDisabled] = useState(false);
  const [partnerDisabled, setPartnerDisabled] = useState(false);
  const [customerDisabled, setCustomerDisabled] = useState(false);

  const intl = useIntl()

  const erpList: any = useSelector<RootState>(({ auth }) => auth.erp, shallowEqual) as any;
  const partner1List: any = useSelector<RootState>(({ auth }) => auth.partner1, shallowEqual) as any;
  const partner2List: any = useSelector<RootState>(({ auth }) => auth.partner2, shallowEqual) as any;
  const status2List: any = useSelector<RootState>(({ auth }) => auth.status2, shallowEqual) as any;
  const rights: any = useSelector<RootState>(({ auth }) => auth.rights, shallowEqual) as any;
  const accountSystem: any = useSelector<RootState>(({ auth }) => auth.accountSystem, shallowEqual) as any;

  const columnList: any = useSelector<RootState>(({ search }) => search.columnList, shallowEqual) as any;
  const columnValues: any = useSelector<RootState>(({ search }) => search.columnValues, shallowEqual) as any;
  const definitions: any = useSelector<RootState>(({ search }) => search.definitions, shallowEqual) as any;
  const serverStatus: any = useSelector<RootState>(({ search }) => search.serverStatus, shallowEqual) as any;
  const partners: any = useSelector<RootState>(({ search }) => search.partnerOptions, shallowEqual) as any;
  const en: any = useSelector<RootState>(({ search }) => search.en, shallowEqual) as any;
  const de: any = useSelector<RootState>(({ search }) => search.de, shallowEqual) as any;

  useEffect(() => {
    document.body.classList.add('bg-grey')
    return () => {
      document.body.classList.remove('bg-grey')
    }
  }, [])

  useEffect(() => {
    // handleCurrentStep(1)
    return () => {
      handleCurrentStep(1)
    };
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [currentStep])

  useEffect(() => {
    if (status2List) {
      setStatusOptions(status2List);

      let newState: any = {}
      status2List.forEach((item: any) => {
        newState[item.status] = false;
      });
      setState(newState);
    }
  }, [status2List])

  useEffect(() => {
    if (rights['admin_allsystems']) {
      if (user?.agent === "nexti") {
      } else {
        setErp(user?.erpsystem);
      }
      setErpOptions(erpList);
      setPartnerOptions(partner1List);
    } else {
      if (rights['admin_erpsystem']) {
        setErp(accountSystem);
        setErpOptions([]);
        setPartnerOptions([]);
      } else {
        setErpOptions(erpList);
        setErp(user?.erpsystem)
        setPartnerOptions(partner1List);
        setPartner(user?.agent);
      }
    }

    if (rights['superuser']) {
      setErpDisabled(false);

    } else {
      setErpDisabled(true);
    }

    if (rights['edit_agent']) {
      setPartnerDisabled(false);
    } else {
      setPartnerDisabled(true);
    }
    if (rights['admin_ownaccount']) {
      setCustomerDisabled(false);
    } else {
      setCustomerDisabled(true);
    }

    // eslint-disable-next-line
  }, [user, rights, partner1List, partner2List, erpList])

  const handleChangeErp = (event: any) => {
    const value = event.target.value;
    const name = event.target.name;
    if (name === 'erp') {
      setErp(value);
    } else if (name === 'partner') {
      setPartner(value);
    }
  }

  useEffect(() => {
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { erp, salt, saltid };
    getPartnerOptions(body)
      .then((res) => {
        dispatch(search.actions.setPartnerOptions(res.data))
      })
      .catch((err) => {

      })
    // eslint-disable-next-line
  }, [erp])

  useEffect(() => {
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { salt, saltid };
    getStatus(body)
      .then((res) => {
        dispatch(auth.actions.setStatus(res.data))
      })
      .catch((err) => {

      })
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (rights['admin_allsystems']) {
      setPartnerOptions(partners);
    } else {
      if (rights['admin_erpsystem']) {
        setPartnerOptions([]);
      } else {
        setPartnerOptions(partners);
      }
    }
    // eslint-disable-next-line
  }, [partners])

  const handleChangeCustomer = (name: any, value: any) => {
    setCustomer(value);
  }

  const handleCheckChange = (event: any) => {
    const value = event.target.checked;
    const name = event.target.name;

    switch (name) {
      case "cloud":
        setCloud(value);
        break;
      case "solo":
        setSolo(value);
        break;
      case "enterprise":
        setEnterprise(value);
        break;
      case "partnerCheck":
        setPartnerCheck(value);
        break;

      default:
        break;
    }
  }

  const handleStatusCheckChange = (event: any) => {
    const value = event.target.checked;
    const name = event.target.name;
    setState((states: any) => ({
      ...states,
      [name]: value
    }))
  }

  const initialValues = {
    username: '',
    password: '',
    systemid: ''
  }

  const formik = useFormik({
    initialValues,
    validationSchema: "",
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      await searchData()
    },
  })

  const searchData = async () => {
    if (currentStep === 2) return;
    setLoading(true);
    setHasIssue(false);
    let systems: any = [];
    let statuses: any = [];
    const tableName = "searchresult"

    if (cloud) {
      systems.push("Cloud");
    }
    if (solo) {
      systems.push("Solo");
    }
    if (enterprise) {
      systems.push("Enterprise");
    }
    if (partnerCheck) {
      systems.push("Partner");
    }

    status2List.forEach((item: any) => {
      if (state[item.status]) {
        statuses.push(item.status);
      }
    });

    let system = ""
    let status = "";
    if (systems.length > 0) {
      system = "'" + systems.join("','") + "'";
    }
    if (statuses.length > 0) {
      status = "'" + statuses.join("','") + "'";
    }

    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { customer, erp, partner, system, status, salt, saltid };
    const body1 = { tableName, salt, saltid };

    try {
      const res = await getSearchData(body)
      const data1 = res.data;
      dispatch(search.actions.getSearchTableData(data1))
      const res1 = await getTranslateData(body1)
      let { data } = res1;
      dispatch(search.actions.getTranslateData(data))
      setLoading(false);
      const columnValues = JSON.parse(data1.data);
      if (columnValues.length === 1) {
        handleNext(columnValues[0].id)
      } else {
        handleCurrentStep(2);
      }
    } catch (error) {
      // debugger
      setHasIssue(true);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (columnValues) {
      setTotalData(columnValues);
    }
  }, [columnValues])

  useEffect(() => {
    let translateData: any = [];
    columnList.forEach((element: any, index: any) => {
      let obj: any = {};
      obj['field'] = element.toLowerCase();
      if (de.length > 0) {
        const value = de[index];
        if (value) {
          if (value.length > 0) {
            if (value[0].text !== null) {
              obj["de"] = value[0].text;
            } else {
              obj["de"] = element;
            }
          } else {
            obj["de"] = element;
          }
        } else {
          obj["de"] = element;
        }
      } else {
        obj["de"] = element;
      }
      if (en.length > 0) {
        const value = en[index];
        if (value) {
          if (value.length > 0) {
            if (value[0].text !== null) {
              obj["en"] = value[0].text;
            } else {
              obj["en"] = element;
            }
          } else {
            obj["en"] = element;
          }
        } else {
          obj["en"] = element;
        }
      } else {
        obj["en"] = element;
      }

      translateData.push(obj);
    });

    setSearchColumns([...translateData]);
  }, [en, de, columnList])

  const handleNext = (id: number) => {
    dispatch(search.actions.setCompanyId(id));
    history.push(`/account/customer/${id}`);
    handleShowCompany(true);
  }

  const handleDelete = (id: any) => {
    const data = totalData.filter((data: any) => data.id !== id);
    setTotalData(data);
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { id, salt, saltid }
    deleteCompany(body)
      .then(() => {

      })
      .catch(() => { })
  }

  return (
    <div className='d-flex  h-100'>
      <HeaderWrapper />
      {
        currentStep === 2 ?
          <Content>
            <div style={{ marginTop: '100px', paddingBottom: '50px' }}>
              <div className='card'>
                <div className='card-body'>
                  <div className='stepper stepper-links d-flex flex-column'>
                    <div className={`mx-auto mw-1500px  w-100`} >
                      <SearchResults
                        totalData={totalData}
                        loading={loading}
                        handleNext={handleNext}
                        handleDelete={handleDelete}
                        headers={columnList}
                        definitions={definitions}
                        searchcolumns={searchColumns}
                        serverStatus={serverStatus}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Content >
          :
          <form
            onSubmit={formik.handleSubmit}
            className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
          >
            <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
              <div className='w-600px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
                <div className='form w-100'>
                  <div >
                    <div className='d-flex justify-content-center align-items-center mb-0'>
                      <div className='text-center pt-3'>
                        <h1 id='login_page_title' className='text-primary'>&nbsp;&nbsp;
                          {intl.formatMessage({ id: 'SEARCH.TITLE' })}
                        </h1>
                      </div>
                    </div>
                    {hasIssue &&
                      <div className='mb-lg-15 alert alert-danger'>
                        <div id='login_error_msg' className='alert-text font-weight-bold'>
                          {
                            intl.formatMessage({ id: 'SEARCH.FAILED' })
                          }
                        </div>
                      </div>
                    }
                    <div className='fv-row mb-5'>
                      {intl.formatMessage({ id: 'SEARCH.ERP' })}
                      <div className='d-flex justify-content-center align-items-center'>
                        <div className='w-100'>
                          <select
                            className='form-select  form-select-sm form-control form-control-sm form-control-solid'
                            style={{ fontSize: '13px', fontWeight: 100 }}
                            value={erp}
                            disabled={erpDisabled}
                            name="erp"
                            onChange={handleChangeErp}
                          >
                            <option value=""></option>
                            {
                              erpOptions?.map((item: any, index: any) => {
                                return (
                                  <option key={index} value={item.name}>{item.name}</option>
                                )
                              })
                            }
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className='fv-row mb-5'>
                      {intl.formatMessage({ id: 'SEARCH.PARTNER' })}
                      <div className='d-flex justify-content-center align-items-center'>
                        <div className='w-100'>
                          <select
                            className='form-select  form-select-sm form-control form-control-sm form-control-solid'
                            style={{ fontSize: '13px', fontWeight: 100 }}
                            value={partner}
                            disabled={partnerDisabled}
                            name="partner"
                            onChange={handleChangeErp}
                          >
                            <option value=""></option>
                            {

                              (rights['admin_erpsystem'] === false || partnerDisabled) &&
                              <option value={'nexti'}>{"Nexti"}</option>
                            }
                            {
                              partnerOptions?.map((item: any, index: any) => {
                                return (
                                  <option key={index} value={item.partner}>{item.partner}</option>
                                )
                              })
                            }
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className='fv-row mb-5'>
                      {intl.formatMessage({ id: 'SEARCH.CUSTOMER' })}
                      <SelectSearch
                        disabled={customerDisabled}
                        handleChange={handleChangeCustomer}
                        value={customer}
                        partner={partner}
                      />
                    </div>

                    <div className='fv-row mb-5'>
                      <div className='row'>
                        <div className='col-md-6'>
                          <div className='form-check form-check-lg form-check-custom form-check-solid mb-3'>
                            <input
                              className='form-check-input widget-9-check'
                              type='checkbox'
                              name='cloud'
                              checked={cloud}
                              onChange={handleCheckChange}
                            />
                            <p style={{ margin: 0, paddingLeft: 20 }}>
                              {intl.formatMessage({ id: 'SEARCH.CLOUD' })}
                            </p>
                          </div>
                          <div className='form-check form-check-lg form-check-custom form-check-solid mb-3'>
                            <input
                              className='form-check-input widget-9-check'
                              type='checkbox'
                              name='solo'
                              checked={solo}
                              onChange={handleCheckChange}
                            />
                            <p style={{ margin: 0, paddingLeft: 20 }}>
                              {intl.formatMessage({ id: 'SEARCH.SOLO' })}
                            </p>
                          </div>
                          <div className='form-check form-check-lg form-check-custom form-check-solid mb-3'>
                            <input
                              className='form-check-input widget-9-check'
                              type='checkbox'
                              name='enterprise'
                              checked={enterprise}
                              onChange={handleCheckChange}
                            />
                            <p style={{ margin: 0, paddingLeft: 20 }}>
                              {intl.formatMessage({ id: 'SEARCH.ENTERPRISE' })}
                            </p>
                          </div>
                          <div className='form-check form-check-lg form-check-custom form-check-solid mb-3'>
                            <input
                              className='form-check-input widget-9-check'
                              type='checkbox'
                              name='partnerCheck'
                              checked={partnerCheck}
                              onChange={handleCheckChange}
                            />
                            <p style={{ margin: 0, paddingLeft: 20 }}>
                              {intl.formatMessage({ id: 'SEARCH.PARTNER' })}
                            </p>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          {
                            statusOptions.map((item: any, index: any) => {
                              return (
                                <div key={index} className='form-check form-check-lg form-check-custom form-check-solid mb-3'>
                                  <input
                                    className='form-check-input widget-9-check'
                                    type='checkbox'
                                    name={item.status}
                                    checked={state[item.status]}
                                    onChange={handleStatusCheckChange}
                                  />
                                  <p style={{ margin: 0, paddingLeft: 20 }}>
                                    {item.status}
                                  </p>
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                    </div>

                    <div className='text-center'>
                      <button
                        type='submit'
                        className='btn btn-lg btn-primary w-100 mb-5'
                      >
                        {!loading && <span className='indicator-label'>
                          {intl.formatMessage({ id: 'SEARCH.SEARCH' })}
                        </span>}
                        {loading && (
                          <span className='indicator-progress' style={{ display: 'block' }}>
                            {intl.formatMessage({ id: 'MENU.WAIT' })}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                </div >
              </div>
            </div>
          </form>
      }

    </div>
  )
}
